<template>
    <div class="formClass">
        <el-form ref="form" :model="dioForm" :rules="dioForm.level === 0 ? {} : rules" inline>
            <el-form-item :label="$t('integration.name')" prop="label">
                <el-input v-if="dioForm.level > 0" v-model.trim="dioForm.label" style="width: 250px;"
                    :placeholder="$t('integration.please_enter_a_name')" />
                <span v-else>
                    {{ dioForm.label }}
                </span>
            </el-form-item>
            <el-form-item>
                <el-button icon="iconfont icon-baocun" @click="handleSave" v-if="dioForm.level !== 0"></el-button>
            </el-form-item>
            <div v-if="funcType === 1 || funcType === 2 || funcType === 3" style="float: right">
                <el-popconfirm
                    v-if="confirmText"
                    :title="confirmText"
                    @confirm="onConfirmSwitch"
                >
                    <el-button
                        slot="reference"
                        type="primary"
                        style="width: 100px;"
                    >
                        {{ funcType === 1 ? $t('integration.map') : $t('integration.plan') }}
                    </el-button>
                </el-popconfirm>
                <el-button
                    v-else
                    slot="reference"
                    type="primary"
                    style="width: 100px;"
                    @click="onConfirmSwitch"
                >
                    {{ funcType === 1 ? $t('integration.map') : $t('integration.plan') }}
                </el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import { sceneUptScene, sceneAddScenePlan, sceneAddSceneMap } from '@/api/modules/architecture.js'

import bus from '@/utils/bus.js';
export default {
    props: ['defaultTreeObj', 'funcType', 'pmObj', 'mapObj', 'treeObj'],
    computed: {
        rules() {
            let codeFn = (rules, value, cb) => {
                let reg = /^[a-zA-Z0-9_-]{0,50}$/;
                if (!reg.test(value)) {
                    cb('编码格式只允许大小写字母、数字、-、_')
                }
                cb()
            }
            return {
                label: [{ required: true, message: $t('integration.name_cannot_be_empty'), trigger: 'blur' },
                {
                    max: 30,
                    message: $t('integration.name_length_is_within_30'),
                    trigger: 'blur'
                }
                ],
                // 区分是否可填校验
                sceneCode: [{ required: true, message: $t('integration.code_cannot_be_empty'), trigger: 'blur' },
                {
                    max: 50,
                    message: $t('integration.code_length_is_within_50'),
                    trigger: 'blur'
                },
                {
                    validator: codeFn,
                    trigger: 'blur'
                }
                ]
            }
        },
        confirmText() {
            // 如果当前是 1，要切到 2，就检查 pmObj；反之检查 mapObj
            return this.funcTypeNew === 1
                ? (this.mapObj && this.mapObj.mapId ? '' : this.$t('integration.no_map_added') )
                : (this.pmObj && this.pmObj.planId ? '' : this.$t('integration.no_plan_added'))
        }
    },
    data() {
        return {
            dioForm: {
            },
            defaultDisabled: false,
            codeUnit: 1,
            funcTypeNew: null
        }
    },
    watch: {
        funcType: {
            handler(newVal) {
                this.funcTypeNew = newVal;
            },
            deep: true
        },
    },
    mounted() {
        this.dioForm = { ...this.defaultTreeObj }
        this.getNodeClickTreeFn();
    },
    methods: {
        changeDefalutFn(id) {
            this.defaultDisabled = !this.defaultDisabled;
            this.dioForm.code = '';
            if (id === 0) {
                this.getSysCode()
            }
        },
        getSysCode() {
            sceneGetGeneSceneCode().then(({ result }) => {
                this.dioForm.sceneCode = result;
            })
        },
        getNodeClickTreeFn() {
            bus.$on('nodeClickTree', row => {
                this.dioForm = { ...row }
            })
        },
        handleSave() {
            const { sceneId, label, sceneCode } = this.dioForm;
            const query = {
                id: sceneId,
                name: label,
                code: sceneCode
            }
            sceneUptScene(query).then(({ result, state }) => {
                if (state.code === 200 && result !== -1 && result !== -2 && result !== 500) {
                    this.$message.success($t('integration.update_successful'));
                    this.isShowDialog = false;
                    bus.$emit('addSuccess')
                }
                else if (result === -1) {
                    this.$message.error($t('integration.name_already_exists'))
                } else if (result === -2) {
                    this.$message.error($t('integration.code_already_exists'))
                } else if (result === -500) {

                    this.$message.error($t('integration.update_failed'))
                } else {
                    this.$message.error(state.msg)
                }
            })
        },
        async onConfirmSwitch() {
            // 如果 confirmText 为空，说明已有数据，直接切换
            if (!this.confirmText) {
                this.doSwitch();
                return;
            }

            // 调用新增接口
            try {
                if (this.funcTypeNew === 1) {
                    const query = {
                        sceneId: this.treeObj.sceneId,
                        longitude: 116.408728,
                        latitude: 39.904039,
                        address: 'default'
                    };
                    await sceneAddSceneMap(query);
                } else {
                    const fd = new FormData();
                    fd.append('sceneId', this.treeObj.sceneId);
                    await sceneAddScenePlan(fd);
                }
                bus.$emit('addSuccess')
                this.$emit('refresh-content', this.funcTypeNew);
                this.doSwitch();
            } catch (e) {
                this.$message.error('新增失败，请稍后再试');
            }
        },
        doSwitch() {
            // 切换 funcType 并通知父组件
            this.funcTypeNew = this.funcTypeNew === 1 ? 2 : 1;
            this.$emit('update:funcType', this.funcTypeNew);
        },
    }
}
</script>

<style lang="scss" scoped>
.formClass {
    height: 50px;

    ::v-deep .icon-baocun {
        color: #344962;
        font-size: 14px;
        font-weight: bold;
    }
}
</style>
